var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.8889,
    height: 40,
    transform: "translate(0.888672)",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6672_16166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6289 12.2961C12.6289 11.1916 13.5243 10.2961 14.6289 10.2961H36.9594L41.6318 14.9461V27.6268C41.6318 28.7314 40.7363 29.6268 39.6318 29.6268H14.6289C13.5243 29.6268 12.6289 28.7314 12.6289 27.6268V12.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 12.2961C12.5098 11.1916 13.4052 10.2961 14.5098 10.2961H24.2402V29.6268H14.5098C13.4052 29.6268 12.5098 28.7314 12.5098 27.6268V12.2961Z",
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4047 23.3759V24.6149H17.6119V23.3759H16.4047ZM15.9219 23.3449C15.9219 23.0883 16.1245 22.8802 16.3746 22.8802H17.6421C17.8921 22.8802 18.0948 23.0883 18.0948 23.3449V24.6459C18.0948 24.9025 17.8921 25.1106 17.6421 25.1106H16.3746C16.1245 25.1106 15.9219 24.9025 15.9219 24.6459V23.3449ZM16.4047 26.1017V27.3407H17.6119V26.1017H16.4047ZM15.9219 26.0707C15.9219 25.8141 16.1245 25.6061 16.3746 25.6061H17.6421C17.8921 25.6061 18.0948 25.8141 18.0948 26.0707V27.3717C18.0948 27.6283 17.8921 27.8364 17.6421 27.8364H16.3746C16.1245 27.8364 15.9219 27.6283 15.9219 27.3717V26.0707ZM19.0608 24.6149V23.3759H20.2679V24.6149H19.0608ZM19.0306 22.8802C18.7806 22.8802 18.5779 23.0883 18.5779 23.3449V24.6459C18.5779 24.9025 18.7806 25.1106 19.0306 25.1106H20.2981C20.5481 25.1106 20.7508 24.9025 20.7508 24.6459V23.3449C20.7508 23.0883 20.5481 22.8802 20.2981 22.8802H19.0306ZM18.8195 25.6061C18.9528 25.6061 19.0609 25.717 19.0609 25.8539V26.5973C19.0609 26.7342 18.9528 26.8451 18.8195 26.8451C18.6861 26.8451 18.578 26.7342 18.578 26.5973V25.8539C18.578 25.717 18.6861 25.6061 18.8195 25.6061ZM20.0266 25.8539C20.0266 25.717 19.9185 25.6061 19.7852 25.6061C19.6518 25.6061 19.5438 25.717 19.5438 25.8539V26.3395L19.5435 26.3505L19.5438 26.3614V27.3407H18.8195C18.6861 27.3407 18.578 27.4517 18.578 27.5886C18.578 27.7254 18.6861 27.8364 18.8195 27.8364H19.7852C19.9185 27.8364 20.0266 27.7254 20.0266 27.5886V26.5983H20.5093C20.6426 26.5983 20.7507 26.4873 20.7507 26.3505C20.7507 26.2136 20.6426 26.1026 20.5093 26.1026H20.0266V25.8539ZM20.7502 27.0932C20.7502 26.9563 20.6422 26.8454 20.5088 26.8454C20.3755 26.8454 20.2674 26.9563 20.2674 27.0932V27.5888C20.2674 27.7257 20.3755 27.8366 20.5088 27.8366C20.6422 27.8366 20.7502 27.7257 20.7502 27.5888V27.0932Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 13.4541C14.1211 12.9018 14.5688 12.4541 15.1211 12.4541H21.5511C22.1034 12.4541 22.5511 12.9018 22.5511 13.4541V19.5538C22.5511 20.106 22.1034 20.5538 21.5511 20.5538H15.1211C14.5688 20.5538 14.1211 20.106 14.1211 19.5538V13.4541Z",
    fill: "#4F5B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3365,
    cy: 15.7033,
    rx: 2.09622,
    ry: 2.18498,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 17.7982L22.5511 20.0623V20.5537H14.1211V17.7982Z",
    fill: "#AEAFC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5508 16.8756L14.1208 20.4602V20.6735C14.1208 21.2258 14.5685 21.6735 15.1208 21.6735H21.5508C22.1031 21.6735 22.5508 21.2258 22.5508 20.6735V16.8756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8164,
    y: 14.9432,
    width: 8.45476,
    height: 2.29666,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8164,
    y: 18.7291,
    width: 9.98683,
    height: 0.904095,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8164,
    y: 23.8474,
    width: 9.98683,
    height: 0.904095,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8164,
    y: 20.2726,
    width: 11.5554,
    height: 0.904093,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8164,
    y: 25.3909,
    width: 11.5554,
    height: 0.904093,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8164,
    y: 21.814,
    width: 10.5099,
    height: 0.904093,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8164,
    y: 26.9323,
    width: 10.5099,
    height: 0.904095,
    fill: "#E2E2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9572 10.3295L41.6315 14.9428L36.957 14.9427L36.9572 10.3295Z",
    fill: "#4F5B94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6672_16166",
    x: 8.50977,
    y: 8.29614,
    width: 37.1211,
    height: 27.3307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.0588235 0 0 0 0 0.14902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6672_16166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6672_16166",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatLetter);
export default __webpack_public_path__ + "static/media/format-letter.e449c2393e29807f422e94d45b0a7dd8.svg";
export { ForwardRef as ReactComponent };